module.exports = __webpack_public_path__ + "img/detailCover.2de6702.png";